__turbopack_context__.v({
  "captcha-field-box": "uxjGUa_captcha-field-box",
});
